import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { BaseServiceService } from 'src/app/services/base-service.service';

@Component({
  selector: 'app-body',
  templateUrl: './body.component.html',
  styleUrl: './body.component.css'
})
export class BodyComponent implements OnInit, OnDestroy {
  
  isHomePage: boolean = false;

  constructor(private router: Router, private baseService: BaseServiceService) {
    this.router.events.subscribe(event => {
      this.isHomePage = this.router.url === '/home';
    });
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  @Input() collapsed = false; 
  @Input() screenWidth = 0;
  @Input() isRedirectAccess = false; 

  getBodyClass():string{
    let styleClass = '';
    
    // Si es acceso desde redirect, ocupar todo el ancho
    if(this.isRedirectAccess) {
      styleClass = 'body-full-width';
    }
    else if(this.collapsed && this.screenWidth > 768){
      styleClass = 'body-trimmed';
    }else if(this.collapsed && this.screenWidth <= 768 && this.screenWidth > 0){
      styleClass= 'body-md-screen'
    }

    return styleClass;
  }

  navigateToProcesos(){
    this.router.navigateByUrl("/home/procesos");
  }
  navigateToFormularios(){
    this.router.navigateByUrl("/home/formularios");
  }
  navigateToUsuarios(){
    this.router.navigateByUrl("/home/usuarios");
  }
  navigateToTareas(){
    this.router.navigateByUrl("/home/tareas");
  }
}
